<section>
      <div layout>
        <cc-activity-overview-chart
          [stats]="stats$ | async"
          class="flex-1"
        ></cc-activity-overview-chart>

        <cc-time-to-first-contact-chart
          class="flex-1"
          [stats]="stats$ | async"
        ></cc-time-to-first-contact-chart>
      </div>

</section>
